import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [form, setForm]     = useState({ email: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">

        {/* Brand */}
        <div className="text-center mb-4">
          <div className="d-inline-flex align-items-center justify-content-center mb-3"
            style={{ width: 52, height: 52, background: '#1e40af', borderRadius: '.75rem' }}>
            <i className="bi bi-mortarboard-fill text-white" style={{ fontSize: '1.5rem' }} />
          </div>
          <h4 className="fw-bold mb-1" style={{ fontSize: '1.125rem' }}>LMS Portal</h4>
          <p className="text-muted mb-0" style={{ fontSize: '.8125rem' }}>Sign in to your account</p>
        </div>

        {error && <div className="alert alert-danger py-2">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              placeholder="you@company.com"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              required
              autoFocus
            />
          </div>
          <div className="mb-4">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter your password"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100 fw-semibold" disabled={loading}
            style={{ padding: '.625rem' }}>
            {loading
              ? <><span className="spinner-border spinner-border-sm me-2" />Signing in…</>
              : 'Sign In'}
          </button>
        </form>

        {/* Role hint */}
        <div className="mt-4 p-3 rounded-3" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
          <p className="mb-2 fw-semibold" style={{ fontSize: '.75rem', color: '#475569' }}>
            WHO USES THIS PORTAL
          </p>
          <div className="d-flex gap-2 mb-1 align-items-start">
            <span className="badge bg-primary-subtle text-primary" style={{ marginTop: 1, flexShrink: 0 }}>Employee</span>
            <span style={{ fontSize: '.75rem', color: '#64748b' }}>
              Log in with your work email to submit monthly reports and track courses.
            </span>
          </div>
          <div className="d-flex gap-2 align-items-start">
            <span className="badge bg-warning-subtle text-warning-emphasis" style={{ marginTop: 1, flexShrink: 0 }}>Admin</span>
            <span style={{ fontSize: '.75rem', color: '#64748b' }}>
              Same login page — use your admin email to manage employees and review reports.
            </span>
          </div>
        </div>

        <p className="text-center text-muted mt-3 mb-0" style={{ fontSize: '.75rem' }}>
          Contact your admin if you need access
        </p>
      </div>
    </div>
  );
}
